<template>
  <div class="apply">
    <h3>{{ activeData && activeData.name }}</h3>
    <!-- <div class="active-title">{{ activeData && activeData.name }}</div> -->
    <div class="active-detail-wp">
      <div>{{ activeData && activeData.detail }}</div>
    </div>
    <div class="active-form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="姓名"
          label="姓名"
          placeholder="姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field name="radio" label="性别">
          <template #input>
            <van-radio-group v-model="sex" direction="horizontal">
              <van-radio name="1" checked-color="#D33A46">男</van-radio>
              <van-radio name="2" checked-color="#D33A46">女</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="phone"
          type="number"
          name="手机号"
          label="手机号"
          placeholder="手机号"
          :rules="[{ required: true, message: '请填写手机号' }]"
        />

        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#D33A46"
            >提交</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import { eventid_detail, applay_eventid } from "network/home";
import qs from "qs";
export default {
  name: "Apply",
  components: {},
  data() {
    return {
      activeData: {},
      username: "",
      phone: "",
      sex: "",
    };
  },
  computed: {},
  created() {
    this.getActiveDetail();
  },
  mounted() {},
  methods: {
    getActiveDetail() {
      eventid_detail(this.$route.query.event_id).then((res) => {
        this.activeData = res.data;
      });
    },
    onSubmit() {
      if (this.username.length < 2) {
        this.$toast("姓名长度不合法");
        return;
      }
      if (!(this.sex == 1 || this.sex == 2)) {
        this.$toast("请选择性别");
        return;
      }
      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regMobile.test(this.phone)) {
        this.$toast("手机号格式错误");
        return;
      }
      const data = {
        event_id: this.$route.query.event_id,
        name: this.username,
        gender: this.sex,
        phone: this.phone,
      };
      applay_eventid(qs.stringify(data)).then((res) => {
        if (res.errors) {
          this.$toast(res.errors.name);
        } else {
          this.$dialog
            .alert({
              message: "报名信息提交成功！请等待客服人员的确认通知！",
            })
            .then(() => {
              this.$router.push({ path: "/" });
            });
        }
      });
    },
  },
};
</script>
<style scoped>
.apply {
  background: #fff;
}
.apply h3 {
  margin: 0 0px;
  padding: 20px 15px;
  font-size: 15px;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid #e5e5e5;
  color: #fff;
  background-color: var(--color-main);
}
.active-title {
  margin-top: 15px;
  font-size: 17px;
  color: #333333;
  text-align: center;
}
.active-detail-wp {
  margin: 15px 10px 10px 10px;
  padding: 15px;
  border-radius: 15px;
  font-size: 13px;
  background-color: #f5f5f5;
  white-space: pre-line;
}
.active-form {
  margin-top: 30px;
}
.active-time {
  margin-top: 10px;
}
</style>